module.exports = __webpack_public_path__ + "static/media/smooth-draw-thumbnail.d8dc9c57.jpg";